import React from 'react';
import { Clock, RefreshCw } from 'lucide-react';

export const StoreClosedScreen = ({ onRetry }: { onRetry: () => void }) => {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex flex-col items-center justify-center p-6 text-center animate-in fade-in zoom-in duration-500">
      <div className="w-24 h-24 bg-slate-200 dark:bg-slate-800 rounded-full flex items-center justify-center mb-6">
        <Clock className="w-12 h-12 text-slate-500 dark:text-slate-400" />
      </div>
      
      <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2">
        Tienda Cerrada
      </h1>
      
      <p className="text-lg text-slate-600 dark:text-slate-400 max-w-md mb-8">
        Lo sentimos, en este momento nuestro sistema no está disponible o el local se encuentra cerrado. Por favor, inténtalo más tarde.
      </p>

      <button
        onClick={onRetry}
        className="flex items-center gap-2 px-6 py-3 bg-pink-500 hover:bg-pink-600 text-white rounded-full font-medium transition-colors shadow-lg shadow-pink-500/25"
      >
        <RefreshCw className="w-5 h-5" />
        Volver a intentar
      </button>
    </div>
  );
};
